import { useEffect, useRef, useState } from "react";

const MODAL_EXPANSION_DELAY_MS = 20;
export const MODAL_CLOSING_DELAY_MS = 1000;

const useSlideOpenClose = (isOpen: boolean) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const closingTimeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
        undefined,
    );

    useEffect(() => {
        if (isOpen) {
            setIsVisible(true);
            const t = setTimeout(
                () => setIsExpanded(true),
                MODAL_EXPANSION_DELAY_MS,
            );

            return () => clearTimeout(t);
        }

        setIsExpanded(false);
        closingTimeoutRef.current = setTimeout(() => {
            setIsVisible(false);
        }, MODAL_CLOSING_DELAY_MS);

        return () => {
            if (closingTimeoutRef.current) {
                clearTimeout(closingTimeoutRef.current);
            }
        };
    }, [isOpen]);

    return { isVisible, isExpanded };
};

export default useSlideOpenClose;
